class Data {
    static checkinTypes = null;
    static isLoading = false;
}

export default Data;